import {IconProps} from './types';

function AiAgentCalendarIcon({fill = 'currentColor', width = 24, height = 24, className}: IconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            stroke={fill}
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            aria-hidden
        >
            <path d="M1.5 3.501H21.5C21.5 3.501 22.5 3.501 22.5 4.501V22.501C22.5 22.501 22.5 23.501 21.5 23.501H1.5C1.5 23.501 0.5 23.501 0.5 22.501V4.501C0.5 4.501 0.5 3.501 1.5 3.501Z" />
            <path d="M3.5 1.501V4.501" />
            <path d="M7.5 1.501V4.501" />
            <path d="M11.5 1.501V4.501" />
            <path d="M15.5 1.501V4.501" />
            <path d="M19.5 1.501V4.501" />
            <path d="M12.5 8.5H15.5V12.5H11.5V9.5C11.5 9.23478 11.6054 8.98043 11.7929 8.79289C11.9804 8.60536 12.2348 8.5 12.5 8.5Z" />
            <path d="M15.5 8.5H18.5C18.7652 8.5 19.0196 8.60536 19.2071 8.79289C19.3946 8.98043 19.5 9.23478 19.5 9.5V12.5H15.5V8.5Z" />
            <path d="M11.5 12.501H15.5V16.501H11.5V12.501Z" />
            <path d="M15.5 12.501H19.5V16.501H15.5V12.501Z" />
            <path d="M11.5 16.501H15.5V20.501H11.5V16.501Z" />
            <path d="M15.5 16.5H19.5V19.5C19.5 19.7652 19.3946 20.0196 19.2071 20.2071C19.0196 20.3946 18.7652 20.5 18.5 20.5H15.5V16.5Z" />
            <path d="M4.5 12.5H7.5V16.5H3.5V13.5C3.5 13.2348 3.60536 12.9804 3.79289 12.7929C3.98043 12.6054 4.23478 12.5 4.5 12.5Z" />
            <path d="M7.5 12.501H11.5V16.501H7.5V12.501Z" />
            <path d="M3.5 16.5H7.5V20.5H4.5C4.23478 20.5 3.98043 20.3946 3.79289 20.2071C3.60536 20.0196 3.5 19.7652 3.5 19.5V16.5Z" />
            <path d="M7.5 16.501H11.5V20.501H7.5V16.501Z" />
        </svg>
    );
}

export default AiAgentCalendarIcon;
